import { useQuery } from '@tanstack/react-query';
import { applyMask } from 'components/MaskedOutput';
import { cdfService } from 'v2/services/cdfService';
import type { IFilterParams } from 'v2/services/cdfService/types';

export const useCdfGetList = (params: IFilterParams) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['cdf', 'getList', params],
    queryFn: async () => {
      const { data } = await cdfService.getList(params);

      if (!data || !Array.isArray(data)) {
        return [];
      }

      const key = params.type === 'received_eduzz' ? 'customer_origin' : 'destination_customer';

      return data.map(entry => ({
        ...entry,
        list: (entry.list || []).map((item: any) => ({
          ...item,
          display: `${item[key].name} - ${applyMask(item[key].document_number, 'cpfCnpj')}`
        }))
      }));
    }
  });

  return {
    list: data ?? [],
    isLoading,
    error
  };
};
